import React from 'react'
import { Link } from 'react-router-dom'
import Style from '../updates.module.css'
import { PATH } from '../../../../app/routes'

const KNOWLEDGE_BASE_URL = 'https://wiki.i95-dev.com'

const LINKS = [
    {
        title: 'Marketplace',
        text: 'Integration products and services for your ERP and eCommerce stack.',
        icon: 'uil-shop',
        to: PATH.MARKETPLACE
    },
    {
        title: 'My Products',
        text: 'Mappings, entities, sync history and setup for each connector.',
        icon: 'uil-apps',
        to: PATH.MY_PRODUCTS
    },
    {
        title: 'Knowledge Base',
        text: 'Guides and walk-throughs for every product and service.',
        icon: 'uil-book-open',
        href: KNOWLEDGE_BASE_URL
    }
]

const CardContent = ({ link }) => (
    <>
        <span className={Style.linkIcon}><i className={link.icon} aria-hidden="true" /></span>
        <span className={Style.linkBody}>
            <span className={Style.linkTitle}>{link.title}</span>
            <span className={Style.linkText}>{link.text}</span>
        </span>
        <i className={`${link.href ? 'uil-external-link-alt' : 'uil-angle-right'} ${Style.linkChevron}`} aria-hidden="true" />
    </>
)

const QuickLinks = () => (
    <nav className={Style.links} aria-label="Quick links">
        {LINKS.map((link) => (link.href ? (
            <a key={link.title} className={Style.linkCard} href={link.href} target="_blank" rel="noreferrer">
                <CardContent link={link} />
                <span className="sr-only">(opens in a new tab)</span>
            </a>
        ) : (
            <Link key={link.title} className={Style.linkCard} to={link.to}>
                <CardContent link={link} />
            </Link>
        )))}
    </nav>
)

export default QuickLinks
